import { setBrandingConfig, getBrandingConfig, setApiConfig, setPusherConfig } from "@/config";

let runtimeConfigLoaded = false;

export async function loadRuntimeConfig() {
  if (runtimeConfigLoaded) {
    return;
  }

  try {
    const response = await fetch("/config.json", {
      cache: "no-store",
    });

    if (response.ok) {
      const json = await response.json();
      if (json.branding) {
        setBrandingConfig(json.branding);
      }
      if (json.api) {
        setApiConfig(json.api);
      }
      if (json.pusher) {
        setPusherConfig(json.pusher);
      }
    } else {
      console.warn("Runtime config not found, using build-time defaults");
    }
  } catch (e) {
    console.warn("Failed to load runtime config, using build-time defaults", e);
  }

  runtimeConfigLoaded = true;
}

export function applyBrandingToDom() {
  const branding = getBrandingConfig();
  if (branding.title) {
    document.title = branding.title;
  }
  if (branding.favicon) {
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = branding.favicon;
  }
}

export default {
  loadRuntimeConfig,
  applyBrandingToDom,
};
